import React, {useContext, useReducer} from "react";
import SnackbarLayout from "../component/snackbar/SnackbarLayout";


const SnackbarStateContext = React.createContext()
const SnackbarDispatchContext = React.createContext()

export function useSnackbarDispatcher() {
    const context = useContext(SnackbarDispatchContext)

    if (!context)
        throw Error('useSnackDispatcher must be use with a SnackProvider')

    return context
}

export function useSnackbarState() {
    const context = useContext(SnackbarStateContext)

    if (!context)
        throw Error('useSnackbarStateDispatcher must be use with a SnackbarProvider')

    return context
}

export function SnackbarProvider({children}) {
    let [state, dispatch] = useReducer(SnackbarReducer, initialState)

    return (
        <SnackbarStateContext.Provider value={state}>
            <SnackbarDispatchContext.Provider value={dispatch}>
                <SnackbarLayout>
                    {children}
                </SnackbarLayout>
            </SnackbarDispatchContext.Provider>
        </SnackbarStateContext.Provider>
    )
}

export const SnackbarActionTypes = {
    SHOW_INFO: 'SHOW_INFO',
    SHOW_SUCCESS: 'SHOW_SUCCESS',
    SHOW_WARNING: 'SHOW_WARNING',
    SHOW_ERROR: 'SHOW_ERROR',
    SHOW_DEFAULT: 'SHOW_DEFAULT',
}

export const initialState = {
    snackbarType: "",
    snackbarMessage: ""
}

function SnackbarReducer(state, action) {
    switch (action.snackbarType) {
        case SnackbarActionTypes.SHOW_INFO:
            return {
                snackbarType: "info",
                snackbarMessage: action.snackbarMessage
            }
        case SnackbarActionTypes.SHOW_ERROR:
            return {
                snackbarType: "error",
                snackbarMessage: action.snackbarMessage
            }
        case SnackbarActionTypes.SHOW_SUCCESS:
            return {
                snackbarType: "success",
                snackbarMessage: action.snackbarMessage
            }
        case SnackbarActionTypes.SHOW_DEFAULT:
            return {
                snackbarType: "",
                snackbarMessage: action.snackbarMessage
            }
        case SnackbarActionTypes.SHOW_WARNING:
            return {
                snackbarType: "warning",
                snackbarMessage: action.snackbarMessage
            }
        default:
            return {
                snackbarType: '',
                snackbarMessage: "NO NO NO NO !!!"
            }

    }
}


export function setSnackbarDispatch(snackbarType, message) {
    return {
        snackbarType: snackbarType,
        snackbarMessage: message
    }
}